export default __webpack_public_path__ + "static/media/placeholder-image.82455e81.svg";